// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"5f172644","59":"f45a6c59","255":"de8d4ef8","417":"1274f32d","453":"c7332fd3","655":"1f6d88a9","725":"ec79afbb","768":"d28b3b37","874":"f3095260"}[chunkId] + ".chunk.js";
};